@import 'styles/mixins';

.container {
  width: 100%;
  position: sticky;
  bottom: 0;
  left: 0;
  @include z-index(mobileToolbar);
  right: 0;
  transform-origin: left bottom;
  transform: translate(0, 0) scale(1);
}
